import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-bold" }

import { computed, onMounted } from 'vue';
import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import {
  SelectFieldValue,
  useCatalogsLoader,
} from 'SharedComponents/Fields/composables/useCatalogsLoader';
import SimpleTextValue from 'SharedComponents/Fields/ViewMode/SimpleTextValue.vue';
import { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import { useValue } from 'SharedDir/common/composables/useValue';
import { SelectFieldParams } from 'SharedDir/declarations/fields';
import { MakeDictionary } from 'SharedDir/utils/helpers';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SelectField' },
  __name: 'SelectValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;

const { innerValue } = useValue(props, emits);

const { loading, options, loadCatalog } = useCatalogsLoader(innerValue, props.params);

const value = computed(() => {
  if (!innerValue.value.value || loading.value) {
    return '';
  }
  const textValue = Array.isArray(innerValue.value.value)
    ? innerValue.value.value
    : [innerValue.value.value];
  const dict = MakeDictionary(options.value, 'value', 'label');
  return textValue.map((id) => dict[id]).join(', ');
});

onMounted(() => loadCatalog(props.params.catalogSlug));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _cache[0] || (_cache[0] = _createTextVNode(" :  ")),
    _createElementVNode("span", null, _toDisplayString(value.value), 1)
  ]))
}
}

})